// extracted by mini-css-extract-plugin
module.exports = {"link":"LoginCheck__link__8227347d"};